import React, { useEffect, useRef, useState } from "react";
import LeftMenu from "../AnalyticsModule/Left";
import { RunnerUpHeader } from "../../ui";
import { Validators } from "../../library/utilities/Validator";
import UploadFile from "../../library/components/FileUpload";
import TextAreaField from "../../library/components/textarea/index";
import {
  ALERT_TYPE_SUCCESS,
  FILED_IS_REQUIRED,
} from "../../constants/constants";
import DateInput from "../../library/components/DateInput";
import Button from "../../library/components/Button";
import { useSubmitObjectStoreUploadMutation } from "../../services/objectStoreServices";
import { createAlert } from "../../features/alert/alerts";
import { useDispatch } from "react-redux";
import {
  useGetAllInstructionRequestQuery,
  useGetInstructionByIdMutation,
  useGetInstructionByIdQuery,
  usePostInstructionMutation,
  useUpdateInstructionMutation,
} from "../../services/announceElection";
import Table from "../../ui/datatable/DataTable";
import { downloadFile } from "../utilities/utils";
import ReactSelect from "../../ui/reactSelect";

const columns1 = [
  {
    Header: "S.No",
    accessor: "S_No",
  },
  {
    Header: "Uploaded Date",
    accessor: "uploaded_date",
  },
  {
    Header: "Subject",
    accessor: "subject",
  },
  {
    Header: "Issue Date",
    accessor: "issue_date",
  },
  {
    Header: "Expiry Date",
    accessor: "expiry_date",
  },
  {
    Header: "No Of Downloads",
    accessor: "no_of_downloads",
  },
  {
    Header: "Is Active",
    accessor: "is_active",
  },
  {
    Header: "Edit",
    accessor: "edit",
  },
];

const userList = [
  {value:"ceo", label:"CEO Level"},
  {value:"deo", label:"DEO Level"},
  {value:"ero", label:"Electoral Registration Officer"},
  {value:"ro", label:"Returning Officer"},
  {value:"nodal", label:"Nodal Officer"},
  {value:"record", label:"Record Officer"},
  {value:"unit", label:"Unit Officer"},

]

const EditRelease = ({ id, refetch, setisVisible }) => {
  const [data, setData] = useState();
  const [selected, setSelected] = useState([]);
  const [errorValue, setErrorValue] = useState({});
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [instructionData, setInstructionData] = useState([]);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState();
  var [uploadData, response] = useSubmitObjectStoreUploadMutation();
  const [updateInstruction, datap] = useUpdateInstructionMutation();
  const { data: GetAllInstruction } = useGetInstructionByIdQuery(id, {
    skip: id === null || id === "" || id === undefined,
  });
  const ref = useRef();
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
      setData((prevState) => ({
        ...prevState,
        [key]: value,
      }));
 
    // if(key==="isActive"){
    //   setData((prevState) => ({
    //     ...prevState,
    //     [key]: value==true?"Y":value==false?"N":null,
    //   }));
    // }
  };

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };

  const getErrorValue = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setErrorValue({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setErrorValue(error);
    }
  };

  const convertDate = (date) => {
    var priorDate = new Date(
      new Date(date).setDate(new Date(date).getDate() + 1)
    );
    return priorDate;
  };

  const subtractDate = (date) => {
    var priorDate = new Date(
      new Date(date).setDate(new Date(date).getDate() - 1)
    );
    return priorDate;
  };


  const onSubmitData = () => {
    let error = {};
    if (!data?.userList || data?.userList === "" || data?.userList.length == 0 ) {
      error["userList"] = "This Field is required";}

    if (!data?.dateOfIssue || data?.dateOfIssue === "") {
      error["dateOfIssue"] = "This field is required";
    }

    if (!data?.dateOfExpiry || data?.dateOfExpiry === "") {
      error["dateOfExpiry"] = "This Field is required";
    }

    if (!data.remarks || data.remarks === "") {
      error["remarks"] = "This Field is required";
    }

   

    if (Object.keys(error).length) {
      setErrorValue(error);
      return;
    }

    var roleList = []
    data?.userList?.map((item)=>{
      roleList.push(item?.value)
    })
    let formdata = new FormData();
    let files = data?.releaseDocument;
    formdata.append("bucketName", "");
    formdata.append("file", files);
    formdata.append("fileType", files?.type);
    formdata.append("fileName", files?.name);
    formdata.append("stateCode", "master");
    formdata.append("acNo", data.Selectedcons);
    formdata.append("type", `ETPBMS`);

    if (formdata !== null && formdata !== {} && data?.releaseDocument!=data?.previouslyreleaseDocument) {
      uploadData(formdata)
        .then((res) => {
          if (res?.error) {
            setIsFileUpload(false);
          } else {
            setIsFileUpload(false);
            ref.current.removeFile();
            updateInstruction({
              allowedRoles:roleList,
              filePath: res?.data?.refId,
              dateOfIssue: data?.dateOfIssue,
              dateOfExpiry: data?.dateOfExpiry,
              subject: data?.remarks,
              isActive:data?.isActive==true?"Y":"N",
              id: id,
            })
              .unwrap()
              .then((responseData) => {
                onSuccess(responseData?.message);
                setData();
                refetch();
                setisVisible(false);
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {
          setIsFileUpload(false);
        });
    } else {
      updateInstruction({
        allowedRoles:roleList,
        filePath: data?.releaseDocument,
        dateOfIssue: data?.dateOfIssue,
        dateOfExpiry: data?.dateOfExpiry,
        subject: data?.remarks,
        isActive:data?.isActive==true?"Y":"N",
        id: id,
      })
        .unwrap()
        .then((responseData) => {
          onSuccess(responseData?.message);
          setData();
          refetch();
          setisVisible(false);
        })
        .catch((err) => {});
      setIsFileUpload(false);
    }
    
  };

  useEffect(() => {
    setData()
    const roleData = []
    if (GetAllInstruction && GetAllInstruction?.payload !== null) {
      setData((...prevState) => ({
        dateOfIssue: GetAllInstruction?.payload?.dateOfIssue,
        dateOfExpiry: GetAllInstruction?.payload?.expiryDate,
        remarks: GetAllInstruction?.payload?.subject,
        releaseDocument: GetAllInstruction?.payload?.filePath,
        previouslyreleaseDocument: GetAllInstruction?.payload?.filePath,
        isActive:GetAllInstruction?.payload?.isActive==="Y"?true:false,
      }));
      const array = GetAllInstruction?.payload?.allowedRoles.slice(1,-1).split(',');
      array.map((item)=>{
        roleData.push({value:item,label:userList.find(obj => obj.value === item)?.label})
      })
      setData((prev)=>({
        ...prev,
        userList:roleData
      }))
    }
  }, [GetAllInstruction]);

  return (
    <>
      <div className="container box shadow ">
        <div className="row  mt-1">
          <div className="col-md-4 mt-2">
            <label className="requiredMark">Date Of Issue</label>
          </div>
          <div className="col-md-8 nullification">
            <DateInput
              label=""
              inputClass="col-md-12"
              value={data?.dateOfIssue}
              onChange={(val) => handleChange("dateOfIssue", val)}
              name="dateOfIssue"
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getErrorValue("dateOfIssue", val)}
              Error={Error}
            />
            {errorValue.dateOfIssue && (
              <div className="text-danger errormsg ml-3">
                {errorValue.dateOfIssue}
              </div>
            )}
          </div>
        </div>
        <div className="row  mt-1">
          <div className="col-md-4 mt-2">
            <label className="requiredMark">Date Of Expiry</label>
          </div>

          <div className="col-md-8 nullification">
            <DateInput
              label=""
              inputClass="col-md-12"
              value={data?.dateOfExpiry}
              disabled={data?.cutOffDate === "" || data?.cutOffDate === null}
              onChange={(val) => handleChange("dateOfExpiry", val)}
              name="dateOfExpiry"
              min={
                data?.dateOfIssue &&
                convertDate(data?.dateOfIssue).toISOString().split("T")[0]
              }
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getErrorValue("dateOfExpiry", val)}
              Error={Error}
            />
            {errorValue.dateOfExpiry && (
              <div className="text-danger errormsg ml-3">
                {errorValue.dateOfExpiry}
              </div>
            )}
          </div>
        </div>
        <div className="row  mt-1">
          <div className="col-md-4 mt-2">
            <label className="requiredMark">Select User Type</label>
          </div>

          <div className="col-md-8 nullification">
              <ReactSelect
                // disabled={false}
                name="userList"
                label=""
                placeholder="Select User Type"
                options={userList}
                valueKey="value"
                labelKey="label"
                labelClass=""
                inputClass="col-md-12"
                getOptionLabel={(data) => data.label}
                getOptionValue={(data) => data.value}
                value={data?.userList?.length>0 ? data?.userList :null}
                isMulti={true}
                handleChange={(val) => handleChange("userList", val)}
                validators={[
                    {
                      check: Validators.required,
                      message: "This field is required",
                    },
                  ]}
                  getError={(val) => getErrorValue("userList", val)}
                  Error={errorValue}
              ></ReactSelect>
          </div>
        </div>
        <div className="row mt-1 my-2">
        <div className="col-md-4 mt-2 ">
            <label className="requiredMark">is Active</label>
          </div>
          <div class="outerDivFull_Instruction col-md-8 mt-2">
            <div class="switchToggle_Instruction">
              <input type="checkbox" id="switch" checked={data?.isActive} onClick={(e)=>handleChange("isActive",e.target.checked)}  />
              <label for="switch">Toggle</label>
            </div>
          </div>
        </div>
        <div className="row mt-1 my-2">
          <div className="col-md-4 mt-2 ">
            <label className="">Upload File</label>
          </div>
          <div className="col-md-8">
            <UploadFile
              name="releaseDocument"
              required={true}
              labelClass="col-10 box"
              inputClass="col-md-12"
              onChange={(val) =>
                handleChange("releaseDocument", val.target.files[0])
              }
              accept=".jpeg,.jpg, .png, .pdf"
              validTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
              size={5000}
              reference={ref}
              validators={[
                {
                  check: Validators.required,
                  message: "this field is required",
                },
              ]}
              getError={(val) => getErrorValue("releaseDocument", val)}
              Error={errorValue}
            />
            <p className="text-success px-3">
              <a
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  fontSize: "10px",
                }}
                onClick={() => {
                  downloadFile(data?.previouslyreleaseDocument);
                }}
              >
                {data?.previouslyreleaseDocument}
              </a>
            </p>
            <p className="text-danger px-3">
              (only .jpg, jpeg, .png and .pdf extension supported)
            </p>
          </div>
        </div>
        <div className="row  mt-1">
          <div className="col-md-4 mt-4">
            <label className="requiredMark">Subject</label>
          </div>

          <div className="col-md-8 nullification">
            <TextAreaField
              type="textrea"
              name="remarks"
              inputClass="col-md-12"
              placeholder="Enter Reason"
              rows="4"
              cols="40"
              maxLength="500"
              value={data?.remarks}
              onChange={(val) => handleChange("remarks", val)}
              getError={(value) => getErrorValue("remarks", value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
                {
                  check: Validators.required,
                  message: "This field is required",
                },
                {
                  check: Validators.nospecialReason,
                  message: "Special Character are not allowed",
                },
              ]}
              getErrorValue={(val) => getErrorValue("remarks", val)}
              Error={errorValue}
            ></TextAreaField>

            <div className="col-md-6" style={{ marginTop: "-16px" }}>
              <p className="text-danger ml-1">*max length 500 characters</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 offset-4 request_button">
            <Button
              value="Update"
              // onClick={onUpdate}
              onClick={() => onSubmitData()}
              id="abc"
              btnClass="btn-class mb-3"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRelease;
